import { Component, OnInit } from '@angular/core';
import { ExperiencesService } from '../experiences/experiences.service';
import { InteractionsService } from '../interactions/interactions.service';
import { InstancesService } from '../../auth/instances.service';
import {Instance} from '../../auth/instance.model';
import * as moment from 'moment';
import {environment} from '../../../environments/environment';
import { Interaction } from '../interactions/interaction.model';
import { Experience } from '../experiences/experience.model';
import { Prize } from '../prizes/prize.model';
import { PrizesService } from '../prizes/prizes.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  instance: Instance = {}
  interactions: Interaction[] = [];
  experiences: Experience[] = [];
  prizes: Prize[] = [];

  moment = moment;
  environment = environment;

  constructor(
    private expService: ExperiencesService,
    private intService: InteractionsService,
    private instService: InstancesService,
    private prizeService: PrizesService
  ) { }

  ngOnInit(): void {
    this.instService.getInstance()
    .subscribe((res: {data: any}) => {
      this.instance = res.data;
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });
    this.intService.getAllInteractions()
    .subscribe((res: {data: any[]}) => {
      this.interactions = res.data;
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });
    this.expService.getAllExperiences()
    .subscribe((res: {data: any[]}) => {
      this.experiences = res.data;
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });
    this.prizeService.getAllPrizes()
    .subscribe((res: {data: any[]}) => {
      this.prizes = res.data;
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });
  }

}
